import {BlockRssComponent} from "./block-rss/block-rss.component";
import {BlockLabelComponent} from "./block-label/block-label.component";
import {BlockSceneComponent} from "./block-scene/block-scene.component";
import {BlockClockComponent} from "./block-clock/block-clock.component";
import {BlockImageComponent} from "./block-image/block-image.component";
import {BlockVideoComponent} from "./block-video/block-video.component";
import {BlockPlaylistComponent} from "./block-playlist/block-playlist.component";
import {BlockJsonItemComponent} from "./block-json-item/block-json-item.component";
import {BlockJsonComponent} from "./block-json/block-json.component";
import {BlockGenericComponent} from "./block-generic/block-generic.component";
import {BlockYoutubeComponent} from "./block-youtube/block-youtube.component";
import {BlockQrComponent} from "./block-qr/block-qr.component";
import {appData, dateStringToUnix, dateToday, dateTomorrow} from "../../../common";
import {BlockCountdownComponent} from "./block-countdown/block-countdown.component";
import {BlockExtVideoComponent} from "./block-ext-video/block-ext-video.component";
import {BlockExtImageComponent} from "./block-ext-image/block-ext-image.component";
import {BlockSliderComponent} from "./block-slider/block-slider.component";
import {BlockButtonComponent} from "./block-button/block-button.component";
import {BlockRadioComponent} from "./block-radio/block-radio.component";
import {BlockCheckboxComponent} from "./block-checkbox/block-checkbox.component";
import {BlockInputComponent} from "./block-input/block-input.component";
import {BlockSwitchComponent} from "./block-switch/block-switch.component";
import {BlockStepperComponent} from "./block-stepper/block-stepper.component";
import {BlockHtmlComponent} from "./block-html/block-html.component";
import {BlockBrowserComponent} from "./block-browser/block-browser.component";
import {BlockExternalComponent} from "./block-external/block-external.component";
import {BlockLocationComponent} from "./block-location/block-location.component";
import {CameraSettings, IAnimationEngine, ICommon, IDataProvider, IFontFormat, ISceneBlock, IPlayerProps} from "../../../interfaces";
import {BlockAdnetComponent} from "./block-adnet/block-adnet.component";
import {BlockCartComponent} from "./block-cart/block-cart.component";
import {BlockLabelqueueComponent} from "./block-labelqueue/block-labelqueue.component";
import {BlockFormComponent} from "./block-form/block-form.component";
import {BlockFasterqComponent} from "./block-fasterq/block-fasterq.component";
import {BlockPodcastComponent} from "./block-podcast/block-podcast.component";
import {BlockCollectionComponent} from "./block-collection/block-collection.component";
import {BlockSceneLoaderComponent} from "./block-scene-loader/block-scene-loader.component";
import {BlockKeyboardComponent} from "./block-keyboard/block-keyboard.component";
import {BlockSerialPortComponent} from "./block-serial-port/block-serial-port.component";
import {BlockKnxComponent} from "./block-knx/block-knx.component";
import {BlockChatComponent} from "./block-chat/block-chat.component";
import {BlockWebcamComponent} from "./block-webcam/block-webcam.component";
import {BlockSchedulerComponent} from "../block-scheduler/block-scheduler.component";
import {BlockHourlybalancerComponent} from "../block-hourlybalancer/block-hourlybalancer.component";
import {getFontIcons} from "../../../common/get-icons";
import {SceneMimeTypes} from "./mime-constants";
import {faAdjust, faArrowsAlt, faBorderStyle, faBraille, faMask, faPalette, faRulerCombined, faSun} from "@fortawesome/free-solid-svg-icons";
import {BlockFlickingComponent} from "./block-flicking/block-flicking.component";
import {BlockCanvaComponent} from "./block-canva/block-canva.component";
import {BlockMusicListComponent} from "./block-music-list/block-music-list.component";
import {BlockMusicComponent} from "./block-music/block-music.component";

export const MAGIC_DIFF = 10;
export const BASIC_COLORS = ['#fff59d', '#ffb74d', '#26c6da', '#fdd835', '#64dd17', '#00bcd4', '#7e57c2', '#90a4ae', '#a1887f', '#ba68c8'];
export const MOVE_DIFF = [1, 10];
export const RESIZE_DIFF = [1, 10];
export const MAX_GUIDELINES = 9999;
export const SCENE_SAVING_INTERVAL = 30000;
export const IMPORT_WAIT_SECONDS = 3000;

// export const DEFAULT_DURATION = 10;

export const animationDefault: Array<IAnimationEngine> = [{
    'In': [
        {
            '$': {
                enabled: '1',
                delay: '0',
                duration: '1000',
                fadeFrq: '1',
                moveFrq: '0',
                moveIntense: '1',
                moveDir: 'fixed',
                moveAngle: '0',
                scaleFrq: '0',
                rotateFrq: '0',
                rotateType: 'fixed',
                rotations: '1',
                blurFrq: '0',
                blurValue: '10',
                textTypingFrq: '0'
            }
        }
    ],
    'Out': [
        {
            '$': {
                enabled: '1',
                delay: '0',
                duration: '1000',
                fadeFrq: '1',
                moveFrq: '0',
                moveIntense: '1',
                moveDir: 'fixed',
                moveAngle: '0',
                scaleFrq: '0',
                rotateFrq: '0',
                rotateType: 'fixed',
                rotations: '1',
                blurFrq: '0',
                blurValue: '10',
                textTypingFrq: '0'
            }
        }
    ],
    'Play': [
        {
            '$': {
                enabled: '0',
                duration: '1000',
                frequency: '1',
                rotateFrq: '0',
                rotateValue: '45',
                fadeFrq: '0',
                scaleFrq: '0',
                scaleValue: '1.5'
            }
        }
    ],
    'Touch': [
        {
            '$': {
                enabled: '1',
                duration: '300',
                scaleValue: '1.2'
            }
        }
    ]
}];


export const SceneEffects = [
    {name: 'Background', translator: 'general.background', icon: faRulerCombined},
    {name: 'Appearance', translator: 'general.appearance', icon: faAdjust},
    {name: 'Border', translator: 'general.border', icon: faBorderStyle},
    {name: 'Shadow', translator: 'general.shadow', icon: faMask},
    {name: 'Glow', translator: 'general.glow', icon: faSun},
    {name: 'Blur', translator: 'general.blur', icon: faBraille}
];

// {name: 'Gradient', translator: 'general.gradient', icon: faPalette},

export interface IAdvancedEvents {
    send: boolean;
    receive: boolean;
    source: boolean;
    filter: boolean;
}

export interface IBlockLabelProp {
    name: string;
    metadata?: any;
    readonly id: string;
    readonly jsonPlayerBased?: boolean;
    readonly jsonItemBased?: boolean;
    readonly dataProviderBlock?: boolean;
    readonly component: BlockRssComponent | BlockLabelComponent | BlockJsonItemComponent | BlockSceneComponent | BlockClockComponent | BlockImageComponent | BlockVideoComponent | BlockQrComponent | BlockMusicListComponent | BlockPlaylistComponent | any;
    readonly release: boolean;
    readonly touch: boolean;
    readonly gpu?: string;
    readonly free: boolean;
    readonly plus: boolean;
    readonly enterprise: boolean;
    readonly advEvents: IAdvancedEvents;
    readonly videoHelp: boolean;
    readonly animation: boolean;
    readonly transitions?: boolean;
    readonly types: string[];
    readonly template: ISceneBlock;
    readonly pop: boolean;
    readonly icon: any;
    readonly category: Array<'Social' | 'Stream' | 'Playback' | 'Remote data' | 'Live feed' | 'Database' | 'Basic' | 'Touch' | 'HTML' | 'Integration'>;
    description: string;
}

export type MimeAnomalyType = 'JSON' | 'CUSTOM_RSS' | 'CUSTOM_RSS_ITEM' | 'XML' | 'XML_ITEM' | 'STOCKS' | 'STOCKS_ITEM' | 'CATALOG' | 'CATALOG_ITEM';
// 'NETFEED_NEWS' | 'NETFEED_HOROSCOPE';


type BlockNames = Readonly<"BLOCKCODE_SCENE" | "RSS" | "CUSTOMRSS" | "XML" | "STOCKS" | "LABEL" | "JSON_VIEWER" | "JSON_PLAYER" | "CLOCK" | "FORM" | "SVG" | "IMAGE" | "VIDEO" | "LOCATION" | "FACEBOOK_WALL" | "FACEBOOK_VIDEO" | "FACEBOOK_ALBUM"
    | "PLAYLIST" | "MUSIC"| "MUSICLIST" | "FLICKING" | "COLLECTION" | "LOADER" | "SCHEDULER" | "HOURLYBALANCER" | "GENERIC" | "WEATHER" | "CALENDAR" | "TWITTER" | "INSTAGRAM_FEED" | "INSTAGRAM_MEDIA" | "COUNTDOWN" | "QR" | "DROPBOX" | "YOUTUBE" | "CAPTURE" | "BROWSER" | "HTML" | "ADNET" | "CART" | "LABELQUEUE" | "ETSY_USER" | "ETSY_SHOP" | "ETSY_LIST"
    | "EXT_VIDEO" | "EXT_IMAGE" | "IFTTT" | "FLICKR" | "DRIVE" | "SLIDER" | "BUTTON" | "RADIO" | "CHECKBOX" | "INPUT" | "FIVEHUNDRED_COLLECTION" | "FIVEHUNDRED_USER" | "YELP_INFO" | "YELP_REVIEWS" | "CATALOG" | "CANVA"
    | "SWITCH" | "STEPPER" | "FASTERQ" | "SPREADSHEET" | "KEYBOARD" | "PODCAST" | "PINTEREST_BOARD" | "PINTEREST_USER" | "TUMBLRTEXTS" | "TUMBLRVIDEOS" | "TUMBLRPHOTOS" | "TUMBLRPOSTS" | "KNX" | "SERIAL_PORT" | "CHAT" | "WEBCAM"
    | "JSONITEM" | "CUSTOMRSS_ITEM" | "CATALOG_ITEM" | "STOCKS_ITEM" | "XML_ITEM" | "FACEBOOK_AYRSHARE" | "FACEBOOK_GROUPS_AYRSHARE" | "GOOGLE_BUSINESS_AYRSHARE" | "INSTAGRAM_AYRSHARE" | "LINKEDIN_AYRSHARE" | "PINTEREST_AYRSHARE" | "REDDIT_AYRSHARE" | "TELEGRAM_AYRSHARE" | "TIKTOK_AYRSHARE" | "X_AYRSHARE" | "YOUTUBE_AYRSHARE"

>;

// | "NETFEED_NEWS" | "NETFEED_HOROSCOPE"

export type IBlockLabelsRecords = Readonly<Partial<Record<BlockNames, IBlockLabelProp>>>;

/**
 the ts definition of:
 type BlockNames = "BLOCKCODE_SCENE" | "RSS" | "LABEL" | "CLOCK" | "IMAGE" | "VIDEO" | "PLAYLIST" | "WEATHER";
 export type IBlockLabelsRecord = Partial<Record<BlockNames, BlockLabelProp>>;

 is equivalent to the following:

 const aa: IBlockLabelsRecords = {
 BLOCKCODE_SCENE: {
 animation: true, advEvents: {source: false, filter: false, receive: false, send: true},
 pop: false, types: [],
 name: '',
 id: '1',
 component: null
 }
 };

 export interface IBlockLabelsDefinition {
 BLOCKCODE_SCENE?: BlockLabelProp;
 RSS?: BlockLabelProp;
 LABEL?: BlockLabelProp;
 CLOCK?: BlockLabelProp;
 IMAGE?: BlockLabelProp;
 VIDEO?: BlockLabelProp;
 PLAYLIST?: BlockLabelProp;
 WEATHER?: BlockLabelProp;
 }
 **/


/******************************************************************************************************************/
// block snippets
/******************************************************************************************************************/

export const fontFormat: IFontFormat = {
    fontSize: '22',
    fontColor: '16777215',
    fontFamily: 'Arial',
    fontWeight: 'normal',
    fontStyle: 'normal',
    textDecoration: 'none',
    textAlign: 'center',
    alignSelf: 'center',
    autoScaling: '1',
    wrap: '1'
};

export const fontFormatTouch: IFontFormat = {
    fontSize: '26',
    fontColor: '16711680',
    fontFamily: 'Arial',
    fontWeight: 'normal',
    fontStyle: 'normal',
    textDecoration: 'none',
    textAlign: 'center',
    alignSelf: 'center',
    autoScaling: '1',
    wrap: '1'
};

const cameraSettings: CameraSettings = {
    bandwidth: "16384",
    captureHeight: "120",
    captureWidth: "160",
    compress: "0",
    favorArea: "1",
    fps: "15",
    index: "1",
    keyFrameInterval: "15",
    quality: "0"
};

const snippetPlayerProps: IPlayerProps = {
    player: '4102',
    folder: '',
    label: 'Playlist',
    autoScaling: '1',
    id: ''
};

const snippetMusicListProps: IPlayerProps = {
    player: '4110',
    folder: '',
    label: 'Music-list',
    autoScaling: '1',
    id: ''
};


const snippetFlickingProps: IPlayerProps = {
    player: '4101',
    folder: '',
    label: 'Swiper',
    autoScaling: '1',
    id: ''
};


const snippetCollectionProps: IPlayerProps = {
    player: '4100',
    folder: '',
    label: 'Collection',
    autoScaling: '1',
    id: ''
};

const snippetSceneLoaderProps: IPlayerProps = {
    player: '4103',
    folder: '',
    label: 'Loader',
    autoScaling: '1',
    id: ''
};

const snippetSequenceProps: IPlayerProps = {
    player: '4120',
    folder: '',
    label: 'HourlyBalancer',
    autoScaling: '1',
    id: ''
};

const snippetSceneSchedulerProps: IPlayerProps = {
    player: '4104',
    folder: '',
    label: 'Scheduler',
    autoScaling: '1',
    id: '',
};


const snippetGenericProps: IPlayerProps = {
    player: '3130',
    folder: '',
    label: 'Generic',
    autoScaling: '1',
    id: ''
};

const snippetSceneProps: IPlayerProps = {
    player: '3510',
    label: 'new scene',
    folder: '',
    autoScaling: '1',
    mimeType: '',
    id: ''
};


const snippetLabelProps: IPlayerProps = {
    player: '3241',
    label: 'Label',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetLabelqueueProps: IPlayerProps = {
    player: '3242',
    label: 'LabelQueue',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetExternalVideoProps: IPlayerProps = {
    player: '3150',
    label: 'Linked Video',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetExternalImageProps: IPlayerProps = {
    player: '3160',
    label: 'Linked Image',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetQRProps: IPlayerProps = {
    player: '3430',
    label: 'QR',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetHtmlProps: IPlayerProps = {
    player: '3235',
    label: 'HTML',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetYouTubeProps: IPlayerProps = {
    player: '4600',
    label: 'YouTube',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetExternalProps: IPlayerProps = {
    player: '3410',
    label: 'Ext/Capture',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetLocationProps: IPlayerProps = {
    player: '4105',
    label: 'Location',
    folder: '',
    autoScaling: '1',
    id: ''
};


const snippetFasterqProps: IPlayerProps = {
    player: '6100',
    label: 'Fasterq',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetBrowserProps: IPlayerProps = {
    player: '5500',
    label: 'Browser',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetButtonProps: IPlayerProps = {
    player: '7000',
    label: 'Button',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetTextInputProps: IPlayerProps = {
    player: '7050',
    label: 'TextInput',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetFormProps: IPlayerProps = {
    player: '3600',
    label: 'Form',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetSliderProps: IPlayerProps = {
    player: '7060',
    label: 'Slider',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetRadioProps: IPlayerProps = {
    player: '7030',
    label: 'Radio',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCheckProps: IPlayerProps = {
    player: '7010',
    label: 'Checkbox',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetAdnetProps: IPlayerProps = {
    player: '3420',
    label: 'AdNet',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCartProps: IPlayerProps = {
    player: '4330',
    label: 'Cart',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetKeyboardProps: IPlayerProps = {
    player: '8000',
    label: 'Keyboard',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetStepperProps: IPlayerProps = {
    player: '7020',
    label: 'Stepper',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetSwitchProps: IPlayerProps = {
    player: '7040',
    label: 'Switch',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetPodcastProps: IPlayerProps = {
    player: '3340',
    label: 'Podcast',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetRssProps: IPlayerProps = {
    player: '3345',
    label: 'Rss',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCatalogItemProps: IPlayerProps = {
    player: '3270',
    label: 'Item',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCatalogProps: IPlayerProps = {
    player: '3280',
    label: 'Catalog Player',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCustomRssItemProps: IPlayerProps = {
    player: '3348',
    label: 'Item',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCustomRssProps: IPlayerProps = {
    player: '3346',
    label: 'CustomRss Player',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCustomStockItemProps: IPlayerProps = {
    player: '3335',
    label: 'Item',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCustomStocksProps: IPlayerProps = {
    player: '3338',
    label: 'Stocks Player',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCustomXmlItemProps: IPlayerProps = {
    player: '4210',
    label: 'Item',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCustomXmlProps: IPlayerProps = {
    player: '4200',
    label: 'XML Player',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetJsonPlayerProps: IPlayerProps = {
    player: '4300',
    label: 'JsonPlayer',
    autoScaling: '1',
    folder: '',
    id: ''
};

const snippetJsonViewerProps: IPlayerProps = {
    player: '4305',
    label: 'JsonViewer',
    autoScaling: '1',
    folder: '',
    id: ''
};

const snippetJsonItemProps: IPlayerProps = {
    player: '4310',
    label: 'Item',
    autoScaling: '1',
    folder: '',
    id: ''
};

const snippetImageItemProps: IPlayerProps = {
    player: '3130',
    label: 'Image',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetMusicItemProps: IPlayerProps = {
    player: '3145',
    label: 'Music',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetSVGItemProps: IPlayerProps = {
    player: '3140',
    label: 'SVG',
    folder: '',
    autoScaling: '1',
    gpu: '0',
    id: ''
};

const snippetVideoItemProps: IPlayerProps = {
    player: '3100',
    label: 'Video',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetTwitterItemProps: IPlayerProps = {
    player: '6230',
    label: 'Twitter',
    folder: '',
    autoScaling: '1',
    id: ''
};

const facebookItemProps: IPlayerProps = {
    player: '6300',
    label: 'Facebook',
    folder: '',
    autoScaling: '1',
    id: ''
};

const facebookGroupsItemProps: IPlayerProps = {
    player: '6305',
    label: 'Facebook Groups',
    folder: '',
    autoScaling: '1',
    id: ''
};

const googleBusinessItemProps: IPlayerProps = {
    player: '6310',
    label: 'Google business',
    folder: '',
    autoScaling: '1',
    id: ''
};

const instagramItemProps: IPlayerProps = {
    player: '6315',
    label: 'Instagram',
    folder: '',
    autoScaling: '1',
    id: ''
};

const linkedinItemProps: IPlayerProps = {
    player: '6320',
    label: 'LinkedIn',
    folder: '',
    autoScaling: '1',
    id: ''
};

const pinterestItemProps: IPlayerProps = {
    player: '6325',
    label: 'Pinterest',
    folder: '',
    autoScaling: '1',
    id: ''
};

const redditItemProps: IPlayerProps = {
    player: '6330',
    label: 'Reddit',
    folder: '',
    autoScaling: '1',
    id: ''
};

const telegramItemProps: IPlayerProps = {
    player: '6335',
    label: 'Telegram',
    folder: '',
    autoScaling: '1',
    id: ''
};

const tiktokItemProps: IPlayerProps = {
    player: '6340',
    label: 'Tiktok',
    folder: '',
    autoScaling: '1',
    id: ''
};

const xItemProps: IPlayerProps = {
    player: '6345',
    label: 'X',
    folder: '',
    autoScaling: '1',
    id: ''
};

const youtubeItemProps: IPlayerProps = {
    player: '6345',
    label: 'YouTube',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetWeatherItemProps: IPlayerProps = {
    player: '6010',
    label: 'Weather',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetYouTubeItemProps: IPlayerProps = {
    player: '6350',
    label: 'YouTube',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetDriveItemProps: IPlayerProps = {
    player: '6060',
    label: 'Drive',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetDropboxItemProps: IPlayerProps = {
    player: '6210',
    label: 'DropBox',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCanvaItemProps: IPlayerProps = {
    player: '5600',
    label: 'Canva',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetIFTTTItemProps: IPlayerProps = {
    player: '6500',
    label: 'IFTTT',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCalendarItemProps: IPlayerProps = {
    player: '6020',
    label: 'Calendar',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetFlickrProps: IPlayerProps = {
    player: '6220',
    label: 'Flickr',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetYelpItemProps: IPlayerProps = {
    player: '6240',
    label: 'Yelp',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetTumblrProps: IPlayerProps = {
    player: '6090',
    label: 'Tumblr',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetPinterestItemProps: IPlayerProps = {
    player: '6080',
    label: 'Pinterest',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippet500pxItemProps: IPlayerProps = {
    player: '6070',
    label: '500px',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetInstagramItemProps: IPlayerProps = {
    player: '6050',
    label: 'Instagram',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetFacebookItemProps: IPlayerProps = {
    player: '4400',
    label: 'Facebook',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetEtsyItemProps: IPlayerProps = {
    player: '6250',
    label: 'Etsy',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetSheetsItemProps: IPlayerProps = {
    player: '6022',
    label: 'Spreadsheets',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetClockItemProps: IPlayerProps = {
    player: '3320',
    label: 'Clock',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetCountdownItemProps: IPlayerProps = {
    player: '3322',
    label: 'Countdown',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetKnxItemProps: IPlayerProps = {
    player: '5010',
    label: 'KNX',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetSerialPortItemProps: IPlayerProps = {
    player: '5000',
    label: 'Serial Port',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetChatItemProps: IPlayerProps = {
    player: '3245',
    label: 'Chat',
    folder: '',
    autoScaling: '1',
    id: ''
};

const snippetWebcamItemProps: IPlayerProps = {
    player: '3350',
    label: 'Webcam',
    folder: '',
    autoScaling: '1',
    id: ''
};

const dataProvider: IDataProvider = {
    eventName: '',
    source: 'external',
    url: '',
    itemsPath: '',
    metadata: '',
    resultEventName: '',
    resultEventParam: ''
};

const dataProviderNetFeedNews: IDataProvider = {
    eventName: '',
    source: 'external',
    url: 'https://secure.digitalsignage.com/rapidapi/google_news/GB/none',
    itemsPath: 'articles',
    metadata: '',
    resultEventName: '',
    resultEventParam: ''
};

const dataProviderNetFeedHoroscope: IDataProvider = {
    eventName: '',
    source: 'external',
    url: 'https://secure.digitalsignage.com/rapidapi/daily_horoscope/libra/none',
    itemsPath: 'horoscope',
    metadata: '',
    resultEventName: '',
    resultEventParam: ''
};


const snippetCommon: ICommon = {
    Layout: [
        {
            $: {
                rotation: '0',
                x: '0',
                y: '0',
                width: '100',
                height: '100',
                locked: 'false'
            }
        }
    ]
};

const pop: ICommon = {
    Stat : [
        {
            $: {
                enabled: '0',
                tag: '0',
                field: '0',
                minThreshold: '0',
                maxThreshold: '0'
            }
        }
    ]
};

const snippetTransitionPool: ICommon = {
    TransitionPool: [
        {
            $: {
                handle: '',
            }
        }
    ]
};

const snippetMusicList: ICommon = {
    Music: [
        {
            $: {
                duration: "5"
            },
            Page: []
        }
    ]
};

const snippetPlaylist: ICommon = {
    Playlist: [
        {
            $: {
                duration: "5"
            },
            Page: []
        }
    ]
};

const snippetFlicking: ICommon = {
    Flicking: [
        {
            $: {
                vertical: "0",
                duration: "5"
            },
            Page: []
        }
    ]
};

const snippetSequencelist: ICommon = {
    HourlyBalancer: [
        {
            $: {
                duration: "5",
                id: ""
                // , fillGaps: "0"
            },
            Page: []
        }
    ]
};

const snippetCollection: ICommon = {
    Collection: [
        {
            $: {
                duration: "5",
                mode: 'kiosk'
            },
            Page: []
        }
    ]
};

// invented for now so I can store load_scene event and event_type 1 (0 = string and 1 = scene id) will need to work with Alon on this
const snippetSceneLoader: ICommon = {
    SceneLoader: [
        {
            $: {
                duration: "5",
                mode: ''
            },
            eventParam: {
                event_name: 'loader',
                access_key: '',
                event_param_id: '',
                event_type: 1,
                event_value: [],
            },
            Page: []
        }
    ]
};

//  invented for now so I can store load_scene event and event_type 1 (0 = string and 1 = scene id) will need to work with Alon on this
const snippetSceneScheduler: ICommon = {
    Schedule: [
        {
            $: {
                id: "",
            }
        }
    ]
};

const snippetScene: ICommon = {
    Scene: [
        {
            $: {
                scrolling: '',
                defaultDuration: '5'
            },
            Layout: [
                {
                    BasicLayout: ['']
                }
            ],
            Players: [
                {
                    Player: []
                }
            ]
        }
    ],
    Layout: [
        {
            $: {
                height: '100',
                rotation: '0',
                width: '100',
                x: '0',
                y: '0'
            }
        }
    ]
};

const snippetLabel: ICommon = {
    Label: [
        {
            Text: [
                "Text..."
            ],
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetLabelqueue: ICommon = {
    LabelQueue: [
        {
            $: {
                duration: '5'
            },
            Font: [
                {
                    $: fontFormat
                }
            ],
            TextList: [
                {
                    Text: [
                        {
                            $: {
                                text: 'text 1',
                                duration: ''
                            }
                        },
                        {
                            $: {
                                text: 'text 2',
                                duration: ''
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const snippetFont = {
    Font: [
        {
            $: fontFormat
        }
    ]
};

const snippetQR: ICommon = {
    Text: [
        {
            _: "https://www.google.com",
            $: {
                fieldName: "",
                textSource: "static"
            }
        }
    ]
};

const snippetExternalImage: ICommon = {
    LINK: [
        {
            $: {
                src: appData.cloudResourcesS3 + '/business1000/resources/scenes_snaps/Account1.png'
            },
            AspectRatio: [
                {
                    $: {
                        maintain: '0'
                    }
                }
            ]
        }
    ]
};

const snippetExternalVideo: ICommon = {
    LINK: [
        {
            $: {
                src: appData.cloudResourcesS3 + '/business1000/resources/samples/1019.mp4'
            },
            Video: [
                {
                    $: {
                        autoRewind: '1',
                        volume: '1'
                    }
                }
            ],
            AspectRatio: [
                {
                    $: {
                        maintain: '0'
                    }
                }
            ]
        }
    ]
};

const snippetKeyboard: ICommon = {
    Keyboards: [
        {
            Keyboard: []
        }
    ]
};

const snippetCart: ICommon = {
    Cart: [
        {
            Player: [
                {
                    $: {
                        src: ''
                    }
                }
            ]
        }
    ]
};

const snippetAdnet: ICommon = {
    AdNet: [
        {
            $: {
                channel: '1',
                defaultMaxInterval: '10',
                mode: 'share'
            },
            DefaultList: [
                {
                    Default: []
                }
            ]

        }
    ]
};

const snippetStepper: ICommon = {
    Stepper: [
        {
            $: {
                defaultValue: '0',
                fieldName: '',
                maximum: '10',
                minimum: '0',
                softKeyboard: '',
                step: '1'
            },
            Font: [
                {
                    $: fontFormatTouch
                }
            ]
        }
    ]
};

const snippetSwitch: ICommon = {
    Switch: [
        {
            $: {
                defaultValue: 'false',
                fieldName: '',
                offLabel: '',
                onLabel: ''
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetCheck: ICommon = {
    Check: [
        {
            $: {
                defaultValue: 'false',
                fieldName: '',
                label: ''
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetForm: ICommon = {
    Form: [
        {
            List: [
                {
                    Item: []
                }
            ],
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetSlider: ICommon = {
    Slider: [
        {
            $: {
                defaultValue: '0',
                fieldName: '',
                maximum: '10',
                minimum: '0',
                step: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetButton: ICommon = {
    Button: [
        {
            $: {
                label: 'Click me'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetRadio: ICommon = {
    Radio: [
        {
            $: {
                fieldName: '',
                label: '',
                value: ''
            }, Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetInput: ICommon = {
    TextInput: [
        {
            $: {
                defaultValue: '',
                fieldName: '',
                softKeyboard: ''
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetKnx: ICommon = {
    Knx: [
        {
            $: {
                ip: "",
                receivedEvent: "",
                sendEvent: ""
            },
        }
    ]
};

const snippetSerialPort: ICommon = {
    SerialPort: [
        {
            $: {},
        }
    ]
};

const snippetChat: ICommon = {
    Label: [
        {
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetWebcam: ICommon = {
    Camera: [
        {
            $: cameraSettings
        }
    ]
};

const snippetHtml: ICommon = {
    HTML: [
        {
            $: {
                config: 'https://www.NationalGeographic.com',
                src: 'https://www.NationalGeographic.com',
                staticTexture: '1'
            }
        }
    ]
};

const snippetFasterq: ICommon = {
    Webkit: [
        {
            Data: [
                {
                    $: {
                        bgColor: 'red',
                        lineID1: '',
                        lineID2: '',
                        lineID3: '',
                        lineID4: '',
                        lineID5: ''
                    }
                }
            ]
        }
    ]
};

const snippetBrowser: ICommon = {
    Webkit: [
        {
            Data: [
                {
                    $: {
                        refresh: '5',
                        urls: 'http://www.google.com,http://digg.com'
                    }
                }
            ]
        }
    ]
};

const snippetLocation: ICommon = {
    "LocationBased": [
        {
            "$": {"duration": "10"},
            "GPS": [],
            "Fixed": []
        }
    ]
};

const snippetExternal: ICommon = {
    ExtApp: [
        {
            $: {
                predefined: ''
            },
            Params: [
                {
                    $: {
                        applyFilter: ""
                    }
                }
            ]
        }
    ]
};

const snippetYouTube: ICommon = {
    YouTube: [
        {
            $: {
                quality: 'default',
                randomOrder: '0',
                listType: 'manually',
                listRegion: 'US',
                category: '',
                channel: '',
                volume: '1'
            },
            VideoIdList: [
                'w0ztlIAYTCU\nAeJ9q45PfD0\nMo1lDsESD90'
            ]
        }
    ]
};

const snippetCustomStocks: ICommon = {
    Stocks: [
        {
            $: {
                playVideoInFull: '1',
                refreshEnabled: '1',
                volume: '1',
                minRefreshTime: '30',
                itemInterval: '5',
                randomOrder: '0',
                displayMode: 'slideShow',
                vertical: '0',
                speed: '10'
            },
            Symbols: [
                "DOW, ^IXIC, ^GSPC, ^TNX, ^FTSE, ^GDAXI, ^FCHI, ^N225, ^HSI, ^STI"
            ],
            Player: [
                {
                    $: {
                        src: '-1'
                    }
                }
            ],
            Page: []
        }
    ]
};

const snippetCustomStockItem: ICommon = {
    StockItem: [
        {
            $: {
                field: 'Symbol',
                negativeColor: '16711680'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        },
    ]
};

const snippetCustomXml: ICommon = {
    Xml: [
        {
            $: {
                url: '',
                slideShow: '1',
                itemsPath: '',
                itemInterval: '5',
                displayMode: 'slideShow',
                minRefreshTime: '30',
                playVideoInFull: '1',
                volume: '1',
                randomOrder: '0',
                refreshEnabled: '1',
                vertical: '0'
            },
            Player: [
                {
                    $: {
                        src: '-1'
                    }
                }
            ],
            Page: []

        }
    ]
};

const snippetCustomXmlItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'text',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetCatalog: ICommon = {
    CatalogItem: [
        {
            $: {
                field: 'name'
            }
        }
    ],
    Catalog: [
        {
            $: {
                kiosk: '1',
                itemInterval: '5',
                displayMode: 'slideShow',
                refreshEnabled: '1',
                playVideoInFull: '1',
                randomOrder: '0',
                minRefreshTime: '30',
                volume: '1',
                vertical: '0'

            },
            Player: [
                {
                    $: {
                        src: '-1'
                    }
                }
            ],
            Categories: [
                {
                    Category: [
                        {
                            $: {
                                id: '-1'
                            }
                        }
                    ]
                }
            ],
            Page: []
        }
    ]
};

const snippetCatalogItem: ICommon = {
    CatalogItem: [
        {
            $: {
                field: 'ItemName'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ],
    XmlItem: [
        {
            $: {
                fieldName: 'text',
                fieldType: 'text',
                maintainAspectRatio: '1'
            }
        }
    ]
};

const snippetCustomRss: ICommon = {
    Rss: [
        {
            $: {
                url: 'http://rss.news.yahoo.com/rss/world',
                minRefreshTime: '30',
                refreshEnabled: '1',
                randomOrder: '0',
            },
            CustomRss: [
                {
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ],
                    $: {
                        url: 'http://rss.news.yahoo.com/rss/world',
                        itemInterval: '5',
                        displayMode: 'slideShow',
                        playVideoInFull: '1',
                        vertical: '0'
                    },
                    Page: []
                }
            ]
        }
    ]
};

const snippetCustomRssItem: ICommon = {
    RssItem: [
        {
            $: {
                field: "title",
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetPodcast: ICommon = {
    Rss: [
        {
            $: {
                minRefreshTime: '30',
                maintainAspectRatio: '1'
            }
        }
    ]
};

const snippetRss: ICommon = {
    Rss: [
        {
            Title: [
                snippetFont
            ],
            Description: [
                snippetFont
            ],
            $: {
                minRefreshTime: '30',
                speed: '20',
                vertical: '1',
                rtl: '0',
                url: 'http://rss.news.yahoo.com/rss/world'
            }
        }
    ]
};

const snippetVideo: ICommon = {
    Resource: [
        {
            $: {
                resource: '__'
            },
            AspectRatio: [
                {
                    $: {
                        maintain: '0'
                    }
                }
            ],
            Video: [
                {
                    $: {
                        autoRewind: '1',
                        volume: '1',
                        backgroundAlpha: '1'
                        // ,useTextureVideo: '0'
                    }
                }
            ]
        }
    ]
};

const snippetClock: ICommon = {
    Clock: [
        {
            $: {
                clockFormat: 'time',
                clockMask: 'L:NN A'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetCountdown: ICommon = {
    Countdown: [
        {
            $: {
                duration: dateStringToUnix(dateTomorrow()),
                finalDate: dateStringToUnix(dateTomorrow()),
                formatText: '%D days and %H:%M:%S Left...',
                mode: 'Date'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetImage: ICommon = {
    Resource: [
        {
            $: {
                staticTexture: '0',
                resource: '__'
            },
            AspectRatio: [
                {
                    $: {
                        maintain: '0'
                    }
                }
            ]
        }
    ]
};

const snippetJsonPlayer: ICommon = {
    Json: [
        {
            $: {
                providerType: '',
                url: '',
                itemsPath: '',
                refreshEnabled: '1',
                minRefreshTime: '30',
                displayMode: 'slideShow',
                dragDropEnabled: '0',
                itemInterval: '5',
                playVideoInFull: '1',
                randomOrder: '1',
                vertical: '0',
                volume: '1'
            },
            Data: [],
            Filters: [
                {
                    'Filter': []
                }
            ],
            Player: [
                {
                    $: {src: ''}
                }
            ]
        }
    ],
    DataProvider: [
        {
            $: dataProvider
        }
    ]
};

const snippetJsonPlayerNetFeedNews: ICommon = {
    Json: [
        {
            $: {
                providerType: '',
                url: 'https://secure.digitalsignage.com/rapidapi/google_news/GB/none',
                itemsPath: 'articles',
                displayMode: 'slideShow',
                dragDropEnabled: '0',
                refreshEnabled: '1',
                minRefreshTime: '30',
                itemInterval: '10',
                playVideoInFull: '1',
                randomOrder: '1'
            },
            Data: [
                {
                    $: {
                        token: '4300.1'
                    }
                }
            ],
            Filters: [
                {
                    'Filter': []
                }
            ],
            Player: [
                {
                    $: {src: ''}
                }
            ]
        }
    ],
    DataProvider: [
        {
            $: dataProviderNetFeedNews
        }
    ]
};

const snippetJsonPlayerNetFeedHoroscope: ICommon = {
    Json: [
        {
            $: {
                providerType: '',
                url: 'https://secure.digitalsignage.com/rapidapi/daily_horoscope/libra/none',
                itemsPath: 'horoscope',
                displayMode: 'slideShow',
                dragDropEnabled: '0',
                refreshEnabled: '1',
                minRefreshTime: '30',
                itemInterval: '10',
                playVideoInFull: '1',
                randomOrder: '1'
            },
            Data: [
                {
                    $: {
                        token: '4300.2'
                    }
                }
            ],
            Filters: [
                {
                    'Filter': []
                }
            ],
            Player: [
                {
                    $: {src: ''}
                }
            ]
        }
    ],
    DataProvider: [
        {
            $: dataProviderNetFeedHoroscope
        }
    ]
};

const snippetJsonViewer: ICommon = {
    Json: [
        {
            $: {
                itemInterval: '60',
                dragDropEnabled: '0',
                intervalEnabled: '0',
                refreshEnabled: '0',
                minRefreshTime: '30',
                vertical: '0',
                volume: '1'
            },
            Player: [
                {
                    $: {src: ''}
                }
            ]
        }
    ],
    DataProvider: [
        {
            $: dataProvider
        }
    ]
};

const snippetJsonItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetSheetsItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: '$cells.1.1.value',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippet500Item: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetInstaFeedItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'urlImage',
                fieldType: 'resource',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetYelpItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'rating',
                fieldType: 'text',
                maintainAspectRatio: '0'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetTumblrItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'date',
                fieldType: 'date',
                maintainAspectRatio: '0'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetPinterestItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'boardName',
                fieldType: 'text',
                maintainAspectRatio: '0'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetInstaMediaItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'urlImage',
                fieldType: 'resource',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetTwitterItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetWeatherItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: '$[0].data.weather[0].maxtemp@',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetDropboxItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'file',
                fieldType: 'object',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetDriveItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'id',
                fieldType: 'object',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetIFTTTItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldType: 'date',
                fieldName: 'value1',
                dateFormat: 'DD/DD/YY',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetCalendarItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldType: "date",
                fieldName: "startDateTime_time",
                dateFormat: "MM/DD/YY",
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetFacebookWallItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldType: "pic",
                fieldName: "pic",
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetFacebookAlbumItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldType: "pic",
                fieldName: "pic",
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetEtsyListingItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldType: "text",
                fieldName: "title",
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetEtsyShopItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldType: "text",
                fieldName: "$story",
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};


const snippetEtsyProfileItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldType: "text",
                fieldName: "$location",
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetFacebookVideosItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldType: "resource",
                fieldName: "src",
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};












const snippetFacebookItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetFacebookGroupsItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetGoogleBusinessItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetInstagramItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetLinkedInItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetRedditItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetTelegramItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetTiktokItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetTwitterAyreshareItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetYoutubeItem: ICommon = {
    XmlItem: [
        {
            $: {
                fieldName: 'name',
                fieldType: 'text',
                maintainAspectRatio: '1'
            },
            Font: [
                {
                    $: fontFormat
                }
            ]
        }
    ]
};

const snippetCanva: ICommon = {
    Canva: [
        {
            $: {
                embeddedLink: ''
            }
        }
    ]
};


const customStocksTemplate: ISceneBlock = {
    $: {
        ...snippetCustomStocksProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCustomStocks
        }
    ]
};

const customStockItemTemplate: ISceneBlock = {
    $: {
        ...snippetCustomStockItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCustomStockItem
        }
    ]
};

const customXmlTemplate: ISceneBlock = {
    $: {
        ...snippetCustomXmlProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCustomXml
        }
    ]
};

const customXmlItemTemplate: ISceneBlock = {
    $: {
        ...snippetCustomXmlItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCustomXmlItem
        }
    ]
};

const customCatalogTemplate: ISceneBlock = {
    $: {
        ...snippetCatalogProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCatalog
        }
    ]
};

const customCatalogItemTemplate: ISceneBlock = {
    $: {
        ...snippetCatalogItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCatalogItem
        }
    ]
};

const customRssTemplate: ISceneBlock = {
    $: {
        ...snippetCustomRssProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCustomRss
        }
    ]
};

const customRssItemTemplate: ISceneBlock = {
    $: {
        ...snippetCustomRssItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCustomRssItem
        }
    ]
};

const podcastTemplate: ISceneBlock = {
    $: {
        ...snippetPodcastProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetPodcast
        }
    ]
};

const rssTemplate: ISceneBlock = {
    $: {
        ...snippetRssProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetRss
        }
    ]
};

const htmlTemplate: ISceneBlock = {
    $: {
        ...snippetHtmlProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetHtml
        }
    ]
};

const facebookVideosTemplate: ISceneBlock = {
    $: {
        ...snippetFacebookItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetFacebookVideosItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: "https://secure.digitalsignage.com/facebook",
                        itemsPath: '',
                        metadata: 'facebook.videos',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'facebook.videos',
                        url: 'https://secure.digitalsignage.com/facebook',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '6',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const etsyUserTemplate: ISceneBlock = {
    $: {
        ...snippetEtsyItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetEtsyProfileItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: "https://secure.digitalsignage.com",
                        itemsPath: '',
                        metadata: 'etsy.userProfile',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'etsy.userProfile',
                        url: 'https://secure.digitalsignage.com/facebook',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '6',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const etsyListingTemplate: ISceneBlock = {
    $: {
        ...snippetEtsyItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetEtsyListingItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: "https://secure.digitalsignage.com",
                        itemsPath: '',
                        metadata: 'etsy.shopListings',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'etsy.shopListings',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '6',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const etsyShopTemplate: ISceneBlock = {
    $: {
        ...snippetEtsyItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetEtsyShopItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: "https://secure.digitalsignage.com",
                        itemsPath: '',
                        metadata: 'etsy.shopAbout',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'etsy.shopAbout',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '6',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const facebookAlbumTemplate: ISceneBlock = {
    $: {
        ...snippetFacebookItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetFacebookAlbumItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: "https://secure.digitalsignage.com/facebook",
                        itemsPath: '',
                        metadata: 'facebook.album',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'facebook.videos',
                        url: 'https://secure.digitalsignage.com/facebook',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '6',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const facebookWallTemplate: ISceneBlock = {
    $: {
        ...snippetFacebookItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetFacebookWallItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: "https://secure.digitalsignage.com/facebook",
                        itemsPath: '',
                        metadata: 'facebook.wall',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'facebook.videos',
                        url: 'https://secure.digitalsignage.com/facebook',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '6',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const browserFasterq: ISceneBlock = {
    $: {
        ...snippetFasterqProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetFasterq
        }
    ]
};

const browserTemplate: ISceneBlock = {
    $: {
        ...snippetBrowserProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetBrowser
        }
    ]
};

const locationTemplate: ISceneBlock = {
    $: {
        ...snippetLocationProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetLocation
        }
    ]
};

const externalTemplate: ISceneBlock = {
    $: {
        ...snippetExternalProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetExternal
        }
    ]
};

const youTubeTemplate: ISceneBlock = {
    $: {
        ...snippetYouTubeProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetYouTube
        }
    ]
};

const textInputTemplate: ISceneBlock = {
    $: {
        ...snippetTextInputProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetInput
        }
    ]
};


const knxTemplate: ISceneBlock = {
    $: {
        ...snippetKnxItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetKnx
        }
    ]
};


const serialPortTemplate: ISceneBlock = {
    $: {
        ...snippetSerialPortItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetSerialPort
        }
    ]
};


const chatTemplate: ISceneBlock = {
    $: {
        ...snippetChatItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetChat
        }
    ]
};


const webcamTemplate: ISceneBlock = {
    $: {
        ...snippetWebcamItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetWebcam
        }
    ]
};

const sliderTemplate: ISceneBlock = {
    $: {
        ...snippetSliderProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetSlider
        }
    ]
};

const formTemplate: ISceneBlock = {
    $: {
        ...snippetFormProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetForm
        }
    ]
};

const buttonTemplate: ISceneBlock = {
    $: {
        ...snippetButtonProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetButton
        }
    ]
};

const checkTemplate: ISceneBlock = {
    $: {
        ...snippetCheckProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCheck
        }
    ]
};

const switchTemplate: ISceneBlock = {
    $: {
        ...snippetSwitchProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetSwitch
        }
    ]
};

const stepperTemplate: ISceneBlock = {
    $: {
        ...snippetStepperProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetStepper
        }
    ]
};

const adnetTemplate: ISceneBlock = {
    $: {
        ...snippetAdnetProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetAdnet
        }
    ]
};

const keyboardTemplate: ISceneBlock = {
    $: {
        ...snippetKeyboardProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetKeyboard
        }
    ]
};

const cartTemplate: ISceneBlock = {
    $: {
        ...snippetCartProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCart,
            DataProvider: [
                {
                    $: {
                        eventName: "",
                        source: "runtime",
                        itemsPath: "",
                        metadata: ""
                    }
                }
            ],
        }
    ]
};

const radioTemplate: ISceneBlock = {
    $: {
        ...snippetRadioProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetRadio
        }
    ]
};

const externalVideoTemplate: ISceneBlock = {
    $: {
        ...snippetExternalVideoProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetExternalVideo
        }
    ]
};

const externalImageTemplate: ISceneBlock = {
    $: {
        ...snippetExternalImageProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetExternalImage
        }
    ]
};

const youQRTemplate: ISceneBlock = {
    $: {
        ...snippetQRProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetQR
        }
    ]
};

const videoTemplate: ISceneBlock = {
    $: {
        ...snippetVideoItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetVideo
        }
    ]
};

const jsonPlayerTemplate: ISceneBlock = {
    $: {
        ...snippetJsonPlayerProps
    },
    Data: [
        {
            ...snippetTransitionPool,
            ...snippetCommon,
            ...snippetJsonPlayer
        }
    ]
};

const jsonPlayerNetFeedNewsTemplate: ISceneBlock = {
    $: {
        ...snippetJsonPlayerProps
    },
    Data: [
        {
            ...snippetTransitionPool,
            ...snippetCommon,
            ...snippetJsonPlayerNetFeedNews
        }
    ]
};

const jsonPlayerNetFeedHoroscopeTemplate: ISceneBlock = {
    $: {
        ...snippetJsonPlayerProps
    },
    Data: [
        {
            ...snippetTransitionPool,
            ...snippetCommon,
            ...snippetJsonPlayerNetFeedHoroscope
        }
    ]
};

const jsonViewerTemplate: ISceneBlock = {
    $: {
        ...snippetJsonViewerProps
    },
    Data: [
        {
            ...snippetTransitionPool,
            ...snippetCommon,
            ...snippetJsonViewer
        }
    ]
};

const jsonItemTemplate: ISceneBlock = {
    $: {
        ...snippetJsonItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetJsonItem
        }
    ]
};

const calendarItemTemplate: ISceneBlock = {
    $: {
        ...snippetCalendarItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCalendarItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/GoogleCalendarEvents',
                        itemsPath: '',
                        metadata: 'calendar',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'calendar',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com/GoogleCalendarEvents'
                    },
                    Data: [
                        {
                            $: {
                                id: '',
                                token: '',
                                mode: 'offset',
                                startDate: dateStringToUnix(dateToday()),
                                endDate: dateStringToUnix(dateTomorrow()),
                                before: '1',
                                after: '1'
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const iftttItemTemplate: ISceneBlock = {
    $: {
        ...snippetIFTTTItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetIFTTTItem,
            DataProvider: [
                {
                    $: {
                        source: "ifttt",
                        url: "",
                        itemsPath: "",
                        metadata: "",
                        eventName: '',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: '',
                        randomOrder: '1',
                        url: "https://secure.digitalsignage.com/GoogleAjaxFileLink/",
                    },
                    Data: [
                        {
                            $: {}
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const driveItemTemplate: ISceneBlock = {
    $: {
        ...snippetDriveItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetDriveItem,
            DataProvider: [
                {
                    $: {
                        source: "external",
                        url: "https://secure.digitalsignage.com/GoogleAjaxFileLink/",
                        itemsPath: "",
                        metadata: "drive",
                        eventName: '',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'drive',
                        randomOrder: '1',
                        url: "https://secure.digitalsignage.com/GoogleAjaxFileLink/",
                    },
                    Data: [
                        {
                            $: {
                                token: "",
                                id: "",  // << google drive
                                filter: "",
                                path: "" // << dropbox
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const dropboxItemTemplate: ISceneBlock = {
    $: {
        ...snippetDropboxItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetDropboxItem,
            DataProvider: [
                {
                    $: {
                        source: "external",
                        url: "https://secure.digitalsignage.com",
                        itemsPath: "",
                        metadata: "dropbox",
                        eventName: '',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'dropbox',
                        randomOrder: '1',
                        url: "https://secure.digitalsignage.com",
                    },
                    Data: [
                        {
                            $: {
                                token: "",
                                id: "",  // << google drive
                                filter: "",
                                path: "" // << dropbox
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const canvaViewerTemplate: ISceneBlock = {
    $: {
        ...snippetCanvaItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCanva,
        }
    ]
}

const fiveHundredCollectionItemTemplate: ISceneBlock = {
    $: {
        ...snippet500pxItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippet500Item,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/500pxPhotos',
                        itemsPath: '',
                        metadata: '500px.collection',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: '500px.collection',
                        url: 'https://secure.digitalsignage.com/500pxPhotos',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [
                        {
                            $: {
                                token: ''
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const fiveHundredUserItemTemplate: ISceneBlock = {
    $: {
        ...snippet500pxItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippet500Item,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/500pxPhotos',
                        itemsPath: '',
                        metadata: '500px.user',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: '500px.user',
                        url: 'https://secure.digitalsignage.com/500pxPhotos',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [
                        {
                            $: {
                                token: ''
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const instaFeedItemTemplate: ISceneBlock = {
    $: {
        ...snippetInstagramItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetInstaFeedItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/InstagramFeed',
                        itemsPath: '',
                        metadata: 'instagram.feed',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'instagram.feed',
                        url: 'https://secure.digitalsignage.com/InstagramFeed',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [
                        {
                            $: {
                                token: ''
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const tumblrPostsTemplate: ISceneBlock = {
    $: {
        ...snippetTumblrProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetTumblrItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/TumblrUserInfo',
                        itemsPath: '',
                        metadata: 'tumblr.posts'
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'tumblr.posts',
                        url: 'https://secure.digitalsignage.com/TumblrUserInfo',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [
                        {
                            $: {
                                token: ''
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const tumblrTextsTemplate: ISceneBlock = {
    $: {
        ...snippetTumblrProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetTumblrItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/TumblrUserInfo',
                        itemsPath: '',
                        metadata: 'tumblr.texts'
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'tumblr.texts',
                        url: 'https://secure.digitalsignage.com/TumblrUserInfo',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [
                        {
                            $: {
                                token: ''
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const tumblrVideosTemplate: ISceneBlock = {
    $: {
        ...snippetTumblrProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetTumblrItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/TumblrUserInfo',
                        itemsPath: '',
                        metadata: 'tumblr.videos'
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'tumblr.videos',
                        url: 'https://secure.digitalsignage.com/TumblrUserInfo',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [
                        {
                            $: {
                                token: ''
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};
const tumblrPhotosTemplate: ISceneBlock = {
    $: {
        ...snippetTumblrProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetTumblrItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/TumblrUserInfo',
                        itemsPath: '',
                        metadata: 'tumblr.photos'
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'tumblr.photos',
                        url: 'https://secure.digitalsignage.com/TumblrUserInfo',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [
                        {
                            $: {
                                token: ''
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const pinterestBoardTemplate: ISceneBlock = {
    $: {
        ...snippetPinterestItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetPinterestItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/PinterestBoardPins',
                        itemsPath: '',
                        metadata: 'pinterest.board'
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'pinterest.board',
                        url: 'https://secure.digitalsignage.com/PinterestBoardPins',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const pinterestUserTemplate: ISceneBlock = {
    $: {
        ...snippetPinterestItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetPinterestItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/PinterestUserPins',
                        itemsPath: '',
                        metadata: 'pinterest.user'
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'pinterest.user',
                        url: 'https://secure.digitalsignage.com/PinterestUserPins',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const yelpInfoTemplate: ISceneBlock = {
    $: {
        ...snippetYelpItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetYelpItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'yelp.info'
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'yelp.info',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const yelpReviewTemplate: ISceneBlock = {
    $: {
        ...snippetYelpItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetYelpItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'yelp.reviews'
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'yelp.reviews',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


const flickrTemplate: ISceneBlock = {
    $: {
        ...snippetFlickrProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetPinterestItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'flickr'
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'flickr',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const instaMediaItemTemplate: ISceneBlock = {
    $: {
        ...snippetInstagramItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetInstaMediaItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/InstagramFeed',
                        itemsPath: '',
                        metadata: 'instagram.media',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        providerType: 'instagram.media',
                        url: 'https://secure.digitalsignage.com/InstagramMedia',
                        itemsPath: '',
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        playVideoInFull: '1',
                        randomOrder: '1'
                    },
                    Data: [
                        {
                            $: {
                                token: ''
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


const twitterItemTemplate: ISceneBlock = {
    $: {
        ...snippetTwitterItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetTwitterItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'cloud',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'twitter',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'twitter',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com'
                    },
                    Data: [
                        {
                            $: {}
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const facebookItemTemplate: ISceneBlock = {
    $: {
        ...facebookItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetFacebookItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'cloud',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'Json.facebook',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'facebook',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com'
                    },
                    Data: [
                        {
                            $: {}
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const facebookGroupsItemTemplate: ISceneBlock = {
    $: {
        ...facebookGroupsItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetFacebookGroupsItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'cloud',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'Json.facebook.groups',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'facebook groups',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com'
                    },
                    Data: [
                        {
                            $: {}
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


const googleBusinessItemTemplate: ISceneBlock = {
    $: {
        ...googleBusinessItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetGoogleBusinessItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'cloud',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'Json.google.business',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'google business',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com'
                    },
                    Data: [
                        {
                            $: {}
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


const instagramItemTemplate: ISceneBlock = {
    $: {
        ...instagramItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetInstagramItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'cloud',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'Json.instagram',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'instagram',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com'
                    },
                    Data: [
                        {
                            $: {}
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


const linkedinItemTemplate: ISceneBlock = {
    $: {
        ...linkedinItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetLinkedInItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'cloud',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'Json.linkedin',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'linkedin',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com'
                    },
                    Data: [
                        {
                            $: {}
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


const pinterestItemTemplate: ISceneBlock = {
    $: {
        ...pinterestItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetPinterestItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'cloud',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'Json.pinterest',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'pinterest',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com'
                    },
                    Data: [
                        {
                            $: {}
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


const redditItemTemplate: ISceneBlock = {
    $: {
        ...redditItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetRedditItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'cloud',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'Json.reddit',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'reddit',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com'
                    },
                    Data: [
                        {
                            $: {}
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


const telegramItemTemplate: ISceneBlock = {
    $: {
        ...telegramItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetTelegramItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'cloud',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'Json.telegram',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'telegram',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com'
                    },
                    Data: [
                        {
                            $: {}
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


const tiktokItemTemplate: ISceneBlock = {
    $: {
        ...tiktokItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetTiktokItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'cloud',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'Json.tiktok',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'tiktok',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com'
                    },
                    Data: [
                        {
                            $: {}
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


const x_ayreshare_ItemTemplate: ISceneBlock = {
    $: {
        ...xItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetTwitterAyreshareItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'cloud',
                        url: 'https://secure.digitalsignage.com',
                        itemsPath: '',
                        metadata: 'Json.x',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'twitter',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com'
                    },
                    Data: [
                        {
                            $: {}
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const youtubeItemTemplate: ISceneBlock = {
    $: {
        ...snippetYouTubeItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetYoutubeItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: '',
                        itemsPath: '',
                        metadata: 'Json.youtube',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        itemInterval: '3600',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'weather',
                        randomOrder: '1',
                        url: ''
                    },
                    Data: [
                        {
                            $: {
                                address: '',
                                style: '',
                                unit: ''
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const weatherItemTemplate: ISceneBlock = {
    $: {
        ...snippetWeatherItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetWeatherItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/Weather',
                        itemsPath: '',
                        metadata: 'weather',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        itemInterval: '3600',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'weather',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com/Weather'
                    },
                    Data: [
                        {
                            $: {
                                address: '91301',
                                style: '1',
                                unit: 'F'
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


const sheetsItemTemplate: ISceneBlock = {
    $: {
        ...snippetSheetsItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetSheetsItem,
            DataProvider: [
                {
                    $: {
                        eventName: '',
                        source: 'external',
                        url: 'https://secure.digitalsignage.com/GoogleSheetsValues',
                        itemsPath: '',
                        metadata: 'spreadsheet',
                        resultEventName: '',
                        resultEventParam: ''
                    }
                }
            ],
            Json: [
                {
                    $: {
                        displayMode: 'slideShow',
                        dragDropEnabled: '0',
                        refreshEnabled: '1',
                        minRefreshTime: '30',
                        itemInterval: '5',
                        itemsPath: '',
                        playVideoInFull: '1',
                        providerType: 'spreadsheet',
                        randomOrder: '1',
                        url: 'https://secure.digitalsignage.com/GoogleSheetsValues'
                    },
                    Data: [
                        {
                            $: {
                                token: ''
                            }
                        }
                    ],
                    Player: [
                        {
                            $: {
                                src: '-1'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};

const countdownTemplate: ISceneBlock = {
    $: {
        ...snippetCountdownItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCountdown
        }
    ]
};

const clockTemplate: ISceneBlock = {
    $: {
        ...snippetClockItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetClock
        }
    ]
};

const imageTemplate: ISceneBlock = {
    $: {
        ...snippetImageItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetImage
        }
    ]
};

const musicTemplate: ISceneBlock = {
    $: {
        ...snippetMusicItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetImage
        }
    ]
};


const svgTemplate: ISceneBlock = {
    $: {
        ...snippetSVGItemProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetImage
        }
    ]
};

const genericTemplate: ISceneBlock = {
    $: {
        ...snippetGenericProps
    },
    Data: [
        {
            ...snippetCommon
        }
    ]
};

const musicListTemplate: ISceneBlock = {
    $: {
        ...snippetMusicListProps
    },
    Data: [
        {
            ...pop,
            ...snippetCommon,
            ...snippetMusicList
        }
    ]
};

const playlistTemplate: ISceneBlock = {
    $: {
        ...snippetPlayerProps
    },
    Data: [
        {
            ...pop,
            ...snippetCommon,
            ...snippetPlaylist
        }
    ]
};

const flickingTemplate: ISceneBlock = {
    $: {
        ...snippetFlickingProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetFlicking
        }
    ]
};

const collectionTemplate: ISceneBlock = {
    $: {
        ...snippetCollectionProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetCollection
        }
    ]
};

const sceneLoaderTemplate: ISceneBlock = {
    $: {
        ...snippetSceneLoaderProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetSceneLoader,
            "EventCommands": [
                {
                    "EventCommand": [
                        {
                            "$": {
                                "from": "loader",
                                "command": "load"
                            }
                        }
                    ]
                }
            ],
        }
    ]
};

const sceneSchedulerTemplate: ISceneBlock = {
    $: {
        ...snippetSceneSchedulerProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetSceneScheduler,
            "EventCommands": [
                {
                    "EventCommand": [
                        {
                            "$": {
                                "from": "loader",
                                "command": "load"
                            }
                        }
                    ]
                }
            ],
        }
    ]
};

const sceneSequenceTemplate: ISceneBlock = {
    $: {
        ...snippetSequenceProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetSequencelist
        }
    ]
};


const labelTemplate: ISceneBlock = {
    $: {
        ...snippetLabelProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetLabel
        }
    ]
};

const labelQueueTemplate: ISceneBlock = {
    $: {
        ...snippetLabelqueueProps
    },
    Data: [
        {
            ...snippetCommon,
            ...snippetLabelqueue
        }
    ]
};

// a
const sceneTemplate: ISceneBlock = {
    $: snippetSceneProps,
    Metadata: [
        {
            Kiosk: [
                {
                    $: {
                        mode: '0',
                        key: 'password'
                    }
                }
            ]
        }
    ],
    Data: [
        {
            ...snippetCommon,
            ...snippetScene,
            // disable animation for now
            // Animation: []
            Animation: animationDefault
        }
    ]
};

export const BlockLabels: Readonly<IBlockLabelsRecords> = {
    BLOCKCODE_SCENE: {id: '3510', component: BlockSceneComponent, description: '', touch: false, release: false, name: 'Scene', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: false}, pop: false, types: ['scene'], template: sceneTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3510'}}).icon, category: []},
    GENERIC: {id: '0', component: BlockGenericComponent, description: '', touch: false, release: false, name: 'Generic', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [SceneMimeTypes.Player], template: genericTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '12050'}}).icon, category: []},

    /**  Item BlockJsonItem mime types components **/
    CUSTOMRSS_ITEM: {id: '3348', transitions: true, jsonItemBased: true, component: BlockJsonItemComponent, description: '', touch: false, release: true, name: 'CustomRSS Item', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [SceneMimeTypes.CustomRss], template: customRssItemTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3348'}}).icon, category: ['Live feed']},
    CATALOG_ITEM: {id: '3270', transitions: true, jsonItemBased: true, component: BlockJsonItemComponent, description: '', touch: false, release: true, name: 'Catalog Item', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [SceneMimeTypes.Catalog], template: customCatalogItemTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3270'}}).icon, category: ['Database']},
    STOCKS_ITEM: {id: '3335', transitions: true, jsonItemBased: true, component: BlockJsonItemComponent, description: '', touch: false, release: true, name: 'Stock Item', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [SceneMimeTypes.Stocks], template: customStockItemTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3335'}}).icon, category: ['Live feed']},
    XML_ITEM: {id: '4210', transitions: true, jsonItemBased: true, component: BlockJsonItemComponent, description: '', touch: false, release: true, name: 'XML Item', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [SceneMimeTypes.XML], template: customXmlItemTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '4210'}}).icon, category: ['Live feed', 'Database']},
    JSONITEM: {
        id: '4310', transitions: true, jsonItemBased: true, component: BlockJsonItemComponent, description: '', touch: false, release: true, name: 'JsonItem', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, template: jsonItemTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '4310'}}).icon, category: ['Live feed', 'Database'], pop: false,
        types: [
            SceneMimeTypes.Weather,
            SceneMimeTypes.IFTTT,
            SceneMimeTypes.Calendar,
            SceneMimeTypes.Twitter,
            SceneMimeTypes.Instagram,
            SceneMimeTypes.InstagramFeed,
            SceneMimeTypes.InstagramMedia,
            SceneMimeTypes.DropBox,
            SceneMimeTypes.GoogleDrive,
            SceneMimeTypes.Facebook,
            SceneMimeTypes.FacebookVideo,
            SceneMimeTypes.FacebookAlbum,
            SceneMimeTypes.FacebookWall,
            SceneMimeTypes.TumblrTexts,
            SceneMimeTypes.TumblrPhotos,
            SceneMimeTypes.TumblrVideos,
            SceneMimeTypes.TumblrPosts,
            SceneMimeTypes.YelpReviews,
            SceneMimeTypes.YelpInfo,
            SceneMimeTypes.FiveHundredCollection,
            SceneMimeTypes.FiveHundredUser,
            SceneMimeTypes.EtsyProfile,
            SceneMimeTypes.EtsyShop,
            SceneMimeTypes.EtsyListing,
            SceneMimeTypes.Flickr,
            SceneMimeTypes.PinterestUser,
            SceneMimeTypes.PinterestBoard,
            SceneMimeTypes.Stocks,
            SceneMimeTypes.Spreadsheet,
            SceneMimeTypes.XML,
            SceneMimeTypes.GoogleBusiness,
            SceneMimeTypes.FacebookGroups,
            SceneMimeTypes.Reddit,
            SceneMimeTypes.LinkedIn,
            SceneMimeTypes.TikTok,
            SceneMimeTypes.YouTube,
            SceneMimeTypes.Pinterest,
            SceneMimeTypes.Telegram,
            SceneMimeTypes.X
        ]

        // SceneMimeTypes.NetFeedNews,
        // SceneMimeTypes.NetFeedHoroscope
    },

    /** Basic blocks **/
    PLAYLIST: {id: '4102', component: BlockPlaylistComponent, description: '', touch: false, release: true, name: 'Playlist', transitions: true, animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: false, send: true}, pop: true, types: [], template: playlistTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '4102'}}).icon, category: ['Basic']},
    MUSICLIST: {id: '4110', component: BlockMusicListComponent, description: '', touch: false, release: true, name: 'Music-list', transitions: false, animation: false, videoHelp: true, advEvents: {source: false, filter: false, receive: false, send: false}, pop: false, types: ['mp3'], template: musicListTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '4110'}}).icon, category: ['Basic']},
    SCHEDULER: {id: '4104', component: BlockSchedulerComponent, description: '', touch: false, release: true, name: 'Scheduler', transitions: true, animation: true, videoHelp: true, advEvents: {filter: false, receive: false, send: false, source: false}, pop: true, types: [], template: sceneSchedulerTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '4104'}}).icon, category: ['Basic']},
    RSS: {id: '3345', component: BlockRssComponent, description: '', touch: true, release: true, name: 'Rss', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: rssTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3345'}}).icon, category: ['Basic', 'Live feed']},
    LABEL: {id: '3241', component: BlockLabelComponent, description: '', touch: false, release: true, name: 'Label', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [], template: labelTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3241'}}).icon, category: ['Basic']},
    LABELQUEUE: {id: '3242', component: BlockLabelqueueComponent, description: '', touch: false, release: true, name: 'Label-Q', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [], template: labelQueueTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3242'}}).icon, category: ['Basic']},
    CLOCK: {id: '3320', component: BlockClockComponent, description: '', touch: false, release: true, name: 'Clock', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: clockTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3320'}}).icon, category: ['Basic']},
    VIDEO: {id: '3100', component: BlockVideoComponent, description: '', touch: false, release: false, name: 'Video', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: ['flv', 'mp4', 'm4v'], template: videoTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3100'}}).icon, category: ['Basic']},
    IMAGE: {id: '3130', component: BlockImageComponent, gpu: '0', description: '', touch: false, release: true, name: 'Image', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: ['jpg', 'png', 'jpeg', 'swf', 'gif'], template: imageTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3130'}}).icon, category: ['Basic']},
    MUSIC: {id: '3145', component: BlockMusicComponent, gpu: '0', description: '', touch: false, release: true, name: 'Music', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: false}, pop: false, types: ['mp3'], template: musicTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3145'}}).icon, category: ['Basic']},
    SVG: {id: '3140', component: BlockImageComponent, gpu: '0', description: '', touch: false, release: true, name: 'Svg', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: ['svg'], template: svgTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3140'}}).icon, category: ['Basic']},
    EXT_VIDEO: {id: '3150', component: BlockExtVideoComponent, description: '', touch: false, release: true, name: 'Ext video', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: externalVideoTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3150'}}).icon, category: ['Basic', 'Remote data', 'HTML']},
    EXT_IMAGE: {id: '3160', component: BlockExtImageComponent, description: '', touch: false, release: true, name: 'Ext image', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: externalImageTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3160'}}).icon, category: ['Basic', 'Remote data', 'HTML']},

    /** Scene components and blocks **/
    COLLECTION: {id: '4100', component: BlockCollectionComponent, description: '', touch: false, release: true, name: 'Collection', transitions: true, animation: true, videoHelp: true, advEvents: {filter: false, receive: true, send: false, source: false}, pop: true, types: [], template: collectionTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4100'}}).icon, category: ['Playback', 'Database']},
    LOADER: {id: '4103', component: BlockSceneLoaderComponent, description: '', touch: false, release: true, name: 'Loader', transitions: true, animation: true, videoHelp: true, advEvents: {filter: false, receive: true, send: false, source: false}, pop: true, types: [], template: sceneLoaderTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4103'}}).icon, category: ['Playback']},
    HOURLYBALANCER: {id: '4120', component: BlockHourlybalancerComponent, description: '', touch: false, release: true, name: 'HourlyBalancer', transitions: true, animation: true, videoHelp: true, advEvents: {filter: false, receive: false, send: false, source: false}, pop: true, types: [], template: sceneSequenceTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4120'}}).icon, category: ['Playback']},
    PODCAST: {id: '3340', component: BlockPodcastComponent, description: '', touch: false, release: false, name: 'Podcast', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: podcastTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '3340'}}).icon, category: ['Live feed']},
    COUNTDOWN: {id: '3322', component: BlockCountdownComponent, description: '', touch: false, release: true, name: 'Countdown', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: countdownTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3322'}}).icon, category: ['Integration']},
    YOUTUBE: {id: '4600', component: BlockYoutubeComponent, description: '', touch: false, release: true, name: 'YouTube', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: false, send: true}, pop: true, types: [], template: youTubeTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4600'}}).icon, category: ['Live feed']},
    LOCATION: {id: '4105', component: BlockLocationComponent, description: '', touch: false, release: true, name: 'Location', transitions: true, animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: locationTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4105'}}).icon, category: ['Integration']},
    HTML: {id: '3235', component: BlockHtmlComponent, description: '', touch: false, release: true, name: 'HTML', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: htmlTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '3235'}}).icon, category: ['Integration', 'HTML']},
    BROWSER: {id: '5500', component: BlockBrowserComponent, description: '', touch: false, release: false, name: 'Browser', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: browserTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '5500'}}).icon, category: ['HTML']},
    CAPTURE: {id: '3410', component: BlockExternalComponent, description: '', touch: false, release: true, name: 'External', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: externalTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '3410'}}).icon, category: ['Integration']},
    JSON_VIEWER: {id: '4305', component: BlockJsonComponent, dataProviderBlock: true, description: '', touch: false, release: true, name: 'JsonViewer', transitions: true, animation: true, videoHelp: true, advEvents: {filter: false, receive: true, send: true, source: false}, pop: true, types: [], template: jsonViewerTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4305'}}).icon, category: ['Database', 'Remote data']},

    /** Json player as well as Json aliased blocks  **/
    JSON_PLAYER: {id: '4300', component: BlockJsonComponent, dataProviderBlock: true, description: '', touch: false, release: true, name: 'JsonPlayer', transitions: true, animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: false}, pop: true, types: [], template: jsonPlayerTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4300'}}).icon, category: ['Database', 'Remote data']},
    // NETFEED_NEWS: {id: '4300.1', component: BlockJsonComponent, dataProviderBlock: false, description: '', touch: false, release: false, name: 'NetFeed News', transitions: true, animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.NetFeedNews], template: jsonPlayerNetFeedNewsTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4300.1'}}).icon, category: ['Live feed']},
    // NETFEED_HOROSCOPE: {id: '4300.2', component: BlockJsonComponent, dataProviderBlock: false, description: '', touch: false, release: false, name: 'NetFeed Horoscope', transitions: true, animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.NetFeedHoroscope], template: jsonPlayerNetFeedHoroscopeTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4300.2'}}).icon, category: ['Live feed']},

    /** JSON Based Components **/
    CALENDAR: {id: '6020', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Calendar', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.Calendar], template: calendarItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6020'}}).icon, category: ['Social']},
    DRIVE: {id: '6060', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Drive', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.GoogleDrive], template: driveItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6060'}}).icon, category: ['Social']},
    SPREADSHEET: {id: '6022', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Spreadsheet', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.Spreadsheet], template: sheetsItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6022'}}).icon, category: ['Social']},
    WEATHER: {id: '6010', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Weather', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.Weather], template: weatherItemTemplate, free: true, plus: true, enterprise: true, icon: getFontIcons({$: {id: '6010'}}).icon, category: ['Basic']},
    IFTTT: {id: '6500', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Ifttt', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.IFTTT], template: iftttItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6500'}}).icon, category: ['Integration']},
    INSTAGRAM_FEED: {id: '6050', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Instagram', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.InstagramFeed, SceneMimeTypes.InstagramMedia], template: instaFeedItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6050'}}).icon, category: ['Social']},
    DROPBOX: {id: '6210', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Dropbox', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.DropBox], template: dropboxItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6210'}}).icon, category: ['Social']},
    
    /** JSON Based Ayrshare service **/
    INSTAGRAM_AYRSHARE: {id: '6315', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Instagram business', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.Instagram], template: instagramItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6315'}}).icon, category: ['Social']},
    FACEBOOK_AYRSHARE: {id: '6300', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Facebook', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.Facebook], template: facebookItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6300'}}).icon, category: ['Social']},
    FACEBOOK_GROUPS_AYRSHARE: {id: '6305', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Facebook Groups', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.FacebookGroups], template: facebookGroupsItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6305'}}).icon, category: ['Social']},
    PINTEREST_AYRSHARE: {id: '6325', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Pinterest', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.Pinterest], template: pinterestItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6325'}}).icon, category: ['Social']},
    TIKTOK_AYRSHARE: {id: '6340', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Tiktok', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.TikTok], template: tiktokItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6340'}}).icon, category: ['Social']},
    X_AYRSHARE: {id: '6345', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'X', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.X], template: x_ayreshare_ItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6345'}}).icon, category: ['Social']},
    LINKEDIN_AYRSHARE: {id: '6320', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'LinkedIn', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.LinkedIn], template: linkedinItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6320'}}).icon, category: ['Social']},

    /** Ayreshare not released yet **/
    GOOGLE_BUSINESS_AYRSHARE: {id: '6310', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Google Business', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.GoogleBusiness], template: googleBusinessItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6310'}}).icon, category: ['Social']},
    YOUTUBE_AYRSHARE: {id: '6350', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'YouTube stream', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.YouTube], template: youtubeItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6350'}}).icon, category: ['Social']},
    TELEGRAM_AYRSHARE: {id: '6335', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Telegram', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.Telegram], template: telegramItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6335'}}).icon, category: ['Social']},
    REDDIT_AYRSHARE: {id: '6330', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Reddit', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.Reddit], template: redditItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6330'}}).icon, category: ['Social']},

    /** Other not released yet **/
    INSTAGRAM_MEDIA: {id: '6050', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Insta Media', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.InstagramMedia, SceneMimeTypes.InstagramFeed], template: instaMediaItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6050'}}).icon, category: ['Social']},
    YELP_INFO: {id: '6240', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Yelp info', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.YelpInfo, SceneMimeTypes.YelpReviews], template: yelpInfoTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6240'}}).icon, category: ['Social']},
    YELP_REVIEWS: {id: '6240', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Yelp reviews', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.YelpReviews, SceneMimeTypes.YelpInfo], template: yelpReviewTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6240'}}).icon, category: ['Social']},
    TWITTER: {id: '6230', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Twitter', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.Twitter], template: twitterItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6230'}}).icon, category: ['Social']},
    PINTEREST_BOARD: {id: '6080', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Pint board', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.PinterestBoard, SceneMimeTypes.PinterestUser], template: pinterestBoardTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6080'}}).icon, category: ['Social']},
    PINTEREST_USER: {id: '6080', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Pint user', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.PinterestUser, SceneMimeTypes.PinterestBoard], template: pinterestUserTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6080'}}).icon, category: ['Social']},
    FACEBOOK_ALBUM: {id: '4400', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'FB Album', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.FacebookAlbum, SceneMimeTypes.FacebookVideo, SceneMimeTypes.FacebookWall], template: facebookAlbumTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4400'}}).icon, category: ['Social']},
    FACEBOOK_VIDEO: {id: '4400', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'FB Video', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.FacebookVideo, SceneMimeTypes.FacebookWall, SceneMimeTypes.FacebookAlbum], template: facebookVideosTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4400'}}).icon, category: ['Social']},
    FACEBOOK_WALL: {id: '4400', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'FB Wall', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.FacebookWall, SceneMimeTypes.FacebookVideo, SceneMimeTypes.FacebookAlbum], template: facebookWallTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4400'}}).icon, category: ['Social']},
    FIVEHUNDRED_COLLECTION: {id: '6070', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: '500px collection', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.FiveHundredCollection, SceneMimeTypes.FiveHundredUser], template: fiveHundredCollectionItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6070'}}).icon, category: ['Social']},
    FIVEHUNDRED_USER: {id: '6070', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: '500px user', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.FiveHundredUser, SceneMimeTypes.FiveHundredCollection], template: fiveHundredUserItemTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6070'}}).icon, category: ['Social']},
    FLICKR: {id: '6220', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Flickr', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.Flickr], template: flickrTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6220'}}).icon, category: ['Social']},
    ETSY_USER: {id: '6250', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Etsy User', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.EtsyProfile, SceneMimeTypes.EtsyShop, SceneMimeTypes.EtsyListing], template: etsyUserTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6250'}}).icon, category: ['Social']},
    ETSY_SHOP: {id: '6250', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Etsy Shop', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.EtsyShop, SceneMimeTypes.EtsyProfile, SceneMimeTypes.EtsyListing], template: etsyShopTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6250'}}).icon, category: ['Social']},
    ETSY_LIST: {id: '6250', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Etsy List', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.EtsyListing, SceneMimeTypes.EtsyShop, SceneMimeTypes.EtsyProfile], template: etsyListingTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6250'}}).icon, category: ['Social']},
    TUMBLRTEXTS: {id: '6090', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Tumblr texts', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.TumblrTexts, SceneMimeTypes.TumblrPosts, SceneMimeTypes.TumblrVideos, SceneMimeTypes.TumblrPhotos], template: tumblrTextsTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6090'}}).icon, category: ['Social']},
    TUMBLRVIDEOS: {id: '6090', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Tumblr videos', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.TumblrVideos, SceneMimeTypes.TumblrPosts, SceneMimeTypes.TumblrTexts, SceneMimeTypes.TumblrPhotos], template: tumblrVideosTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6090'}}).icon, category: ['Social']},
    TUMBLRPHOTOS: {id: '6090', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Tumblr photos', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.TumblrPhotos, SceneMimeTypes.TumblrPosts, SceneMimeTypes.TumblrVideos, SceneMimeTypes.TumblrTexts], template: tumblrPhotosTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6090'}}).icon, category: ['Social']},
    TUMBLRPOSTS: {id: '6090', jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: false, name: 'Tumblr posts', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [SceneMimeTypes.TumblrPosts, SceneMimeTypes.TumblrTexts, SceneMimeTypes.TumblrVideos, SceneMimeTypes.TumblrPhotos], template: tumblrPostsTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6090'}}).icon, category: ['Social']},
    
    /** Integration **/
    CHAT: {id: '3245', component: BlockChatComponent, description: '', touch: false, release: false, name: 'Chat', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: true, send: true}, pop: false, types: [], template: chatTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '3245'}}).icon, category: ['Integration']},
    ADNET: {id: '3420', component: BlockAdnetComponent, description: '', touch: false, release: true, name: 'AdNet', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [], template: adnetTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '3420'}}).icon, category: ['Integration']},
    WEBCAM: {id: '3350', component: BlockWebcamComponent, description: '', touch: false, release: true, name: 'Webcam', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: webcamTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '3350'}}).icon, category: ['Integration']},
    FASTERQ: {id: '6100', component: BlockFasterqComponent, description: '', touch: false, release: true, name: 'FasterQ', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [], template: browserFasterq, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '6100'}}).icon, category: ['Integration']},
    CANVA: {id: '5600', component: BlockCanvaComponent, description: '', touch: false, release: true, name: 'Canva', animation: true, videoHelp: true, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [], template: canvaViewerTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '5600'}}).icon, category: ['Integration']},
    KNX: {id: '5010', component: BlockKnxComponent, description: '', touch: false, release: false, name: 'KNX', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: knxTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '5010'}}).icon, category: []},

    /** XML Based components **/
    CUSTOMRSS: {id: '3346', jsonItemBased: false, jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'CustomRss', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: true, send: true}, pop: false, types: [SceneMimeTypes.CustomRss], template: customRssTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3346'}}).icon, category: ['Live feed']},
    CATALOG: {id: '3280', jsonItemBased: false, jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Catalog', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: true, send: true}, pop: false, types: [SceneMimeTypes.Catalog], template: customCatalogTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3280'}}).icon, category: ['Database']},
    STOCKS: {id: '3338', jsonItemBased: false, jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'Stocks', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: true, send: true}, pop: false, types: [SceneMimeTypes.Stocks], template: customStocksTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3338'}}).icon, category: ['Live feed']},
    XML: {id: '4200', jsonItemBased: false, jsonPlayerBased: true, transitions: true, component: BlockJsonComponent, description: '', touch: false, release: true, name: 'XML', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: true, send: true}, pop: true, types: [SceneMimeTypes.XML], template: customXmlTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '4200'}}).icon, category: ['Database', 'Remote data']},

    /** Touch components **/
    QR: {id: '3430', component: BlockQrComponent, description: '', touch: false, release: true, name: 'QR', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: youQRTemplate, free: false, plus: true, enterprise: true, icon: getFontIcons({$: {id: '3430'}}).icon, category: ['Integration', 'Touch', 'Remote data']},
    FLICKING: {id: '4101', component: BlockFlickingComponent, description: '', touch: false, release: true, name: 'Swiper', transitions: true, animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: true, send: false}, pop: false, types: [], template: flickingTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4101'}}).icon, category: ['Touch']},
    BUTTON: {id: '7000', component: BlockButtonComponent, description: '', touch: false, release: true, name: 'Button', animation: true, videoHelp: true, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: buttonTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '7000'}}).icon, category: ['Touch']},
    FORM: {id: '3600', component: BlockFormComponent, description: '', touch: false, release: false, name: 'Form', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: formTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '3600'}}).icon, category: ['Touch']},
    SLIDER: {id: '7060', component: BlockSliderComponent, description: '', touch: false, release: true, name: 'Slider', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: sliderTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '7060'}}).icon, category: ['Touch']},
    RADIO: {id: '7030', component: BlockRadioComponent, description: '', touch: false, release: true, name: 'Radio', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: radioTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '7030'}}).icon, category: ['Touch']},
    CHECKBOX: {id: '7010', component: BlockCheckboxComponent, description: '', touch: false, release: true, name: 'Checkbox', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: checkTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '7010'}}).icon, category: ['Touch']},
    SWITCH: {id: '7040', component: BlockSwitchComponent, description: '', touch: false, release: true, name: 'Switch', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: switchTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '7040'}}).icon, category: ['Touch']},
    STEPPER: {id: '7020', component: BlockStepperComponent, description: '', touch: false, release: true, name: 'Stepper', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: stepperTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '7020'}}).icon, category: ['Touch']},
    CART: {id: '4330', component: BlockCartComponent, dataProviderBlock: true, description: '', touch: false, release: false, name: 'Cart', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [], template: cartTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '4330'}}).icon, category: ['Touch']},
    KEYBOARD: {id: '8000', component: BlockKeyboardComponent, description: '', touch: false, release: false, name: 'Keyboard', animation: true, videoHelp: false, advEvents: {filter: true, receive: true, send: true, source: true}, pop: false, types: [], template: keyboardTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '8000'}}).icon, category: ['Touch']},
    INPUT: {id: '7050', component: BlockInputComponent, description: '', touch: false, release: true, name: 'Input', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: textInputTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '7050'}}).icon, category: ['Touch']},
    SERIAL_PORT: {id: '5000', component: BlockSerialPortComponent, description: '', touch: false, release: false, name: 'Serial Port', animation: true, videoHelp: false, advEvents: {source: false, filter: false, receive: false, send: true}, pop: false, types: [], template: serialPortTemplate, free: false, plus: false, enterprise: true, icon: getFontIcons({$: {id: '5000'}}).icon, category: ['Touch']},
};


